(function () {
  var CDN = {
    three: 'https://cdn.jsdelivr.net/npm/three@0.130.1/build/three.min.js',
    gsap:  'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js',
    st:    'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/ScrollTrigger.min.js'
  };

  function loadScript(src) {
    return new Promise(function (res, rej) {
      var s = document.createElement('script');
      s.src = src;
      s.onload = res;
      s.onerror = function () { rej(new Error('Failed: ' + src)); };
      document.head.appendChild(s);
    });
  }

  // GLTFLoader is hosted as a theme asset (downloaded from three.js r130)
  var el = document.getElementById('stadium-scroll-section');
  var gltfUrl = el ? el.dataset.gltfLoaderUrl : null;

  Promise.all([
    loadScript(CDN.three),
    loadScript(CDN.gsap)
  ]).then(function () {
    return Promise.all([
      loadScript(gltfUrl),
      loadScript(CDN.st)
    ]);
  }).then(setup).catch(function (e) {
    console.error('[stadium-scroll] load error:', e);
  });

  function setup() {
    gsap.registerPlugin(ScrollTrigger);
    ScrollTrigger.normalizeScroll(true);

    var container = document.getElementById('stadium-scroll-container');
    if (!container) { console.error('[stadium-scroll] container not found'); return; }

    var canvas = document.getElementById('stadium-canvas');

    var scene = new THREE.Scene();
    scene.background = new THREE.Color(0x0a0a0a);

    var camera = new THREE.PerspectiveCamera(45, container.offsetWidth / container.offsetHeight, 0.1, 200);
    camera.position.set(0, 5, 25);
    camera.lookAt(0, 0, 0);

    var renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true });
    renderer.setSize(container.offsetWidth, container.offsetHeight);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 1.2;

    // Sky/ground gradient for natural base tone
    scene.add(new THREE.HemisphereLight(0xdce8ff, 0x2a1f0f, 0.5));
    // Strong top-down key — like floodlights or noon sun
    var sun = new THREE.DirectionalLight(0xfff8e8, 4.0);
    sun.position.set(2, 30, 4);
    scene.add(sun);
    // Soft side fill so shadowed faces aren't pure black
    var fill = new THREE.DirectionalLight(0x8aaad0, 0.6);
    fill.position.set(-12, 4, 8);
    scene.add(fill);
    var rim = fill; // kept as ref for animation compatibility

    var loader = new THREE.GLTFLoader();
    loader.load(
      container.dataset.modelUrl,
      function (gltf) {
        var stadium = gltf.scene;
        var box    = new THREE.Box3().setFromObject(stadium);
        var center = box.getCenter(new THREE.Vector3());
        var size   = box.getSize(new THREE.Vector3());
        var scale  = 10 / Math.max(size.x, size.y, size.z);
        stadium.scale.setScalar(scale);
        stadium.position.sub(center.multiplyScalar(scale));
        scene.add(stadium);
        buildScrollAnimation(stadium, camera, rim);
      },
      undefined,
      function (err) { console.error('[stadium-scroll] GLB error:', err); }
    );

    window.addEventListener('resize', function () {
      camera.aspect = container.offsetWidth / container.offsetHeight;
      camera.updateProjectionMatrix();
      renderer.setSize(container.offsetWidth, container.offsetHeight);
    });

    (function animate() { requestAnimationFrame(animate); renderer.render(scene, camera); })();
  }

  function buildScrollAnimation(stadium, camera, rim) {
    var section = document.getElementById('stadium-scroll-section');
    var notes   = document.querySelectorAll('.stadium-note');

    var tl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: 'top top',
        end: '+=300%',
        scrub: 1.5,
        pin: true,
        pinSpacing: true,
        anticipatePin: 1,
      }
    });

    tl.to(camera.position, { z: 16, y: 4, duration: 1, ease: 'power1.inOut' }, 0)
      .to(stadium.rotation, { y: Math.PI * 0.4, duration: 1, ease: 'power1.inOut' }, 0);

    tl.to(camera.position, { z: 10, y: 3, duration: 1, ease: 'power2.inOut' }, 1)
      .to(stadium.rotation, { y: Math.PI * 0.8, duration: 1, ease: 'power1.inOut' }, 1)
      .to(rim, { intensity: 4, duration: 1 }, 1);

    tl.to(camera.position, { z: 7, y: 13, duration: 1, ease: 'power2.inOut' }, 2)
      .to(stadium.rotation, { y: Math.PI * 1.2, duration: 1, ease: 'power1.inOut' }, 2)
      .to(rim, { intensity: 1, duration: 1 }, 2);

    var noteTimes = [0.15, 1.1, 2.1, 2.7];
    notes.forEach(function (note, i) {
      var t = noteTimes[i] !== undefined ? noteTimes[i] : i;
      tl.fromTo(note,
        { opacity: 0, y: 24, scale: 0.92 },
        { opacity: 1, y: 0, scale: 1, duration: 0.25, ease: 'back.out(1.7)' }, t
      ).to(note, { opacity: 0, y: -20, duration: 0.2, ease: 'power1.in' }, t + 0.65);
    });
  }

})();
